import {
    FETCH_CRITERIA_SUCCESS,
    FETCH_CRITERIA_PROJECTION_SUCCESS,
    CRITERIA_REQUEST_LOADING,
    CRITERIA_REQUEST_ERRORS,
    SET_SELECTED_CRITERION,
    CLEAR_SELECTED_CRITERION,
    FETCH_KEYWORDS_SUCCESS,
    KEYWORDS_REQUEST_LOADING,
    KEYWORDS_REQUEST_ERRORS,
    UPDATE_KEYWORD_COUNT
} from "api/menu/hr/scoring-criteria/actions";

const initialState = {
    criteria: [],
    criteriaProjection: [],
    selectedCriterionId: null,
    keywords: [],
    keywordCounts: {}, // Track keyword counts per criterion { criterionId: count }
    loading: {
        criteria: false,
        keywords: false
    },
    errors: {
        criteria: [],
        keywords: []
    }
};

export default function(state = initialState, action) {
    switch (action.type) {
        case CRITERIA_REQUEST_LOADING:
            return { 
                ...state, 
                loading: { ...state.loading, criteria: true },
                errors: { ...state.errors, criteria: [] }
            };
        
        case CRITERIA_REQUEST_ERRORS:
            return { 
                ...state, 
                loading: { ...state.loading, criteria: false },
                errors: { ...state.errors, criteria: action.payload }
            };
        
        case FETCH_CRITERIA_SUCCESS:
            return { 
                ...state, 
                loading: { ...state.loading, criteria: false },
                criteria: action.payload,
                errors: { ...state.errors, criteria: [] }
            };
        
        case FETCH_CRITERIA_PROJECTION_SUCCESS:
            return { 
                ...state, 
                criteriaProjection: action.payload
            };
        
        case SET_SELECTED_CRITERION:
            return { 
                ...state, 
                selectedCriterionId: action.payload,
                keywords: [], // Clear keywords when switching criteria
                loading: { ...state.loading, keywords: false },
                errors: { ...state.errors, keywords: [] }
            };
        
        case CLEAR_SELECTED_CRITERION:
            return { 
                ...state, 
                selectedCriterionId: null,
                keywords: [],
                loading: { ...state.loading, keywords: false },
                errors: { ...state.errors, keywords: [] }
            };
        
        case KEYWORDS_REQUEST_LOADING:
            return { 
                ...state, 
                loading: { ...state.loading, keywords: true },
                errors: { ...state.errors, keywords: [] }
            };
        
        case KEYWORDS_REQUEST_ERRORS:
            return { 
                ...state, 
                loading: { ...state.loading, keywords: false },
                errors: { ...state.errors, keywords: action.payload }
            };
        
        case FETCH_KEYWORDS_SUCCESS:
            const keywords = action.payload;
            const criterionId = action.criterionId || state.selectedCriterionId;
            return { 
                ...state, 
                loading: { ...state.loading, keywords: false },
                keywords: keywords,
                keywordCounts: {
                    ...state.keywordCounts,
                    [criterionId]: keywords.length
                },
                errors: { ...state.errors, keywords: [] }
            };
        
        case UPDATE_KEYWORD_COUNT:
            return {
                ...state,
                keywordCounts: {
                    ...state.keywordCounts,
                    [action.payload.criterionId]: action.payload.count
                }
            };
        
        default:
            return state;
    }
}
